import { getItem } from '@/utils/storage'

export const getHeaders = () => {
    return {
        'x-access-token': getItem(localStorage, 'token'),
        'x-sistema': 'COCKPIT',
        'x-sistema-legivel': 'Cockpit',
        'x-versao': import.meta.env.VITE_VERSION,
    }
}
